import { useQuery } from '@tanstack/react-query';
import type { IPaginationParams } from 'v2/interfaces/pagination';
import productService from 'v2/services/product';

interface MyProductsFilters {
  moderation_status?: string;
  status?: string;
  order?: string;
  title?: string;
  exact_title?: string;
  filter_fix_delivery?: boolean;
}

export const useMyProducts = (filters: MyProductsFilters, pagination: IPaginationParams) => {
  const {
    data: response,
    isFetching,
    isSuccess,
    refetch
  } = useQuery({
    queryKey: ['myProducts', pagination.current_page, pagination.per_page, filters],
    queryFn: () => productService.listMyProducts(filters, pagination)
  });

  return {
    data: response?.data ?? [],
    pagination: response?.pagination,
    isFetching,
    isCompleted: isSuccess && Array.isArray(response?.data),
    refetch
  };
};
